import { ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IGeneralInformationV2Output {
    company: ICompanyNameIdLegalFormDTO;
    accountingBasis: INameId;
    arTemplate: INameId;
    locale: INameId;
    reportType: INameId;
    currency: INameId;
    displayCurrency?: INameId;
    balanceSheetDate: Date;
    balancePreviousYearDate?: Date;
    incomeCurrentYearFromDate: Date;
    incomeCurrentYearToDate: Date;
    incomePreviousYearFromDate?: Date;
    incomePreviousYearToDate?: Date;
    hasPreviousData: boolean;
    autofillFromPreviousForBalance?: boolean;
    autofillReportForBalance?: INameId;
    autofillFromPreviousForIncome?: boolean;
    autofillReportForIncome?: INameId;
}
